//  @jsx h

import { h } from 'preact';
var style = {
  'icon': 'dhfc-1_0_0-beta_26-icon'
};


function Icon(props) {
  var className = '' + style.icon + (props.className ? ' ' + props.className : '');

  return h('svg', {
    className: className,
    'aria-hidden': props['aria-hidden'],
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#nrk-' + props.symbol + '" />'
    }
  });
}

export default Icon;


// WEBPACK FOOTER //
// ./node_modules/@nrk/dh-feature-components/dist/module/core/Icon/index.js